/* eslint-disable @typescript-eslint/no-explicit-any */
export function removeEmptyValuesFromFilterData(object) {
    if (typeof object === 'object' && !Array.isArray(object)) {
        for (const key of Object.keys(object)) {
            const value = object[key];
            if (value === false) {
                // remove false
                delete object[key];
            }
            else if (typeof value === 'string' && !value) {
                // remove empty string
                delete object[key];
            }
            else if (Array.isArray(value) && value.length === 0) {
                // remove empty array
                delete object[key];
            }
        }
    }
    return object;
}
